module.exports = __webpack_public_path__ + "img/tailor.8d667faf.png";